import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SearchIcon, CalendarIcon, UsersIcon } from 'lucide-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
const SearchBar = ({
  className = ''
}) => {
  const [destination, setDestination] = useState('');
  const [checkInDate, setCheckInDate] = useState(null);
  const [checkOutDate, setCheckOutDate] = useState(null);
  const [guests, setGuests] = useState(1);
  const navigate = useNavigate();
  const handleSearch = e => {
    e.preventDefault();
    const params = new URLSearchParams();
    if (destination) params.append('destination', destination);
    if (checkInDate) params.append('checkIn', checkInDate.toISOString().split('T')[0]);
    if (checkOutDate) params.append('checkOut', checkOutDate.toISOString().split('T')[0]);
    params.append('guests', guests.toString());
    navigate(`/search?${params.toString()}`);
  };
  return <div className={`bg-white rounded-lg shadow-lg p-4 md:p-6 ${className}`} data-id="element-600">
      <form onSubmit={handleSearch} data-id="element-601">
        <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4" data-id="element-602">
          <div className="flex-1" data-id="element-603">
            <label htmlFor="destination" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-604">
              Where
            </label>
            <div className="relative" data-id="element-605">
              <SearchIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-606" />
              <input id="destination" type="text" placeholder="Search destinations" value={destination} onChange={e => setDestination(e.target.value)} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" data-id="element-607" />
            </div>
          </div>
          <div className="md:w-1/5" data-id="element-608">
            <label htmlFor="check-in" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-609">
              Check-in
            </label>
            <div className="relative" data-id="element-610">
              <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-611" />
              <DatePicker id="check-in" selected={checkInDate} onChange={date => setCheckInDate(date)} selectsStart startDate={checkInDate} endDate={checkOutDate} minDate={new Date()} placeholderText="Add date" className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" data-id="element-612" />
            </div>
          </div>
          <div className="md:w-1/5" data-id="element-613">
            <label htmlFor="check-out" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-614">
              Check-out
            </label>
            <div className="relative" data-id="element-615">
              <CalendarIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-616" />
              <DatePicker id="check-out" selected={checkOutDate} onChange={date => setCheckOutDate(date)} selectsEnd startDate={checkInDate} endDate={checkOutDate} minDate={checkInDate || new Date()} placeholderText="Add date" className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none" data-id="element-617" />
            </div>
          </div>
          <div className="md:w-1/6" data-id="element-618">
            <label htmlFor="guests" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-619">
              Guests
            </label>
            <div className="relative" data-id="element-620">
              <UsersIcon className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" data-id="element-621" />
              <select id="guests" value={guests} onChange={e => setGuests(parseInt(e.target.value))} className="pl-10 w-full p-3 border border-gray-300 rounded-md focus:ring-[#D4A017] focus:border-[#D4A017] outline-none appearance-none" data-id="element-622">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(num => <option key={num} value={num} data-id="element-623">
                    {num} {num === 1 ? 'guest' : 'guests'}
                  </option>)}
              </select>
            </div>
          </div>
          <div className="md:self-end md:pb-0.5" data-id="element-624">
            <button type="submit" className="w-full md:w-auto bg-[#FF6B6B] hover:bg-[#ff5252] text-white px-6 py-3 rounded-md font-medium transition-colors flex items-center justify-center" data-id="element-625">
              <SearchIcon className="h-5 w-5 mr-2" data-id="element-626" />
              Search
            </button>
          </div>
        </div>
      </form>
    </div>;
};
export default SearchBar;